import { h } from 'preact';

export default function ServiceStatusBadge({ isConfigured, isRequired }) {
  const baseClasses =
    'inline-flex items-center gap-1.5 px-2.5 py-1 h-7 border rounded-full text-xs md:text-sm font-medium';

  if (isConfigured) {
    return (
      <div
        className={`${baseClasses} bg-coit-success border-transparent text-white`}
      >
        <svg
          className="w-4 h-4 shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M5 13l4 4L19 7"
          />
        </svg>
        <span>Completed</span>
      </div>
    );
  }

  if (isRequired) {
    return (
      <div
        className={`${baseClasses} bg-yellow-100 border-yellow-500 text-yellow-800`}
      >
        <span className="text-coit-error text-sm leading-none">*</span>
        <span>Need Information</span>
      </div>
    );
  }

  return null;
}
